import React from 'react';
import { AlertCircle } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * Inline field error message component
 * Displays error with icon and text below form fields
 */
export const FieldError = ({ message, className }) => {
  if (!message) return null;

  return (
    <div className={cn('flex items-start gap-2 mt-1.5 text-sm text-destructive', className)}>
      <AlertCircle className="h-4 w-4 flex-shrink-0 mt-0.5" />
      <span>{message}</span>
    </div>
  );
};

export default FieldError;
